import type { FunctionComponent } from 'react';

import { Button, ButtonSize } from '../../../shared/components/button/button';
import { ContextLink } from '../../../shared/components/context-link/context-link';
import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { createStyleHelper } from '../../../shared/utils/class-names';

import styles from './cookie-banner.module.scss';

const style = createStyleHelper(styles, 'cookie-banner');

export interface ICookieBannerProps {
    onAccept?: () => void;
}

export const CookieBanner: FunctionComponent<ICookieBannerProps> = ({ onAccept }) => {
    return (
        <div className={style()}>
            <p>
                <FormattedMessage
                    id="cookie-banner.information"
                    defaultMessage="Crab Sports uses cookies to improve your experience. Please read and accept our <privacy-policy>Privacy and Cookie Policy</privacy-policy>."
                    values={{
                        'privacy-policy': (tokens) => {
                            return (
                                <ContextLink
                                    className={style('link')}
                                    to="/documents/privacy-policy"
                                >
                                    {tokens}
                                </ContextLink>
                            );
                        },
                    }}
                />
            </p>

            <Button onClick={onAccept} size={ButtonSize.MEDIUM}>
                <FormattedMessage id="cookie-banner.accept" defaultMessage="Accept" />
            </Button>
        </div>
    );
};
